import { useCallback, useMemo } from 'react';

import {
  TOTAL_REMOTE_LOADING_TIME,
  TRACKING_ACTIONS,
  TrackingMetadata,
  trackLoadingTime,
} from '@adsk/exo-skeleton-api';

export type TrackingRemoteReadyData = { metadata?: TrackingMetadata };
export type TrackReadyCallback = (data?: TrackingRemoteReadyData) => void;

export interface RemotePerformanceTrackingValue {
  trackLoading: () => void;
  trackReady: TrackReadyCallback;
}

export function useTrackingPerformanceFactory(
  scope: string,
  moduleName: string,
  isRemoteAlreadyInitialized: boolean | undefined,
) {
  const sharedTrackingData = useMemo(
    () => ({
      scope,
      moduleName,
      isRemoteAlreadyInitialized,
      trackingId: TOTAL_REMOTE_LOADING_TIME,
    }),
    [scope, moduleName, isRemoteAlreadyInitialized],
  );

  const trackLoading = useCallback(() => {
    return trackLoadingTime({
      ...sharedTrackingData,
      action: TRACKING_ACTIONS.START,
    });
  }, [sharedTrackingData]);

  const trackReady = useCallback<TrackReadyCallback>(
    (data) => {
      return trackLoadingTime({
        ...sharedTrackingData,
        action: TRACKING_ACTIONS.END,
        ...data,
      });
    },
    [sharedTrackingData],
  );

  return { trackLoading, trackReady };
}
